import React, { Fragment, useState } from 'react'
import { sanitize } from 'dompurify'
import { useSpring, animated } from 'react-spring'
import { Icon } from 'semantic-ui-react'
import { sequenceAnimations } from '../animations'
import * as easings from 'd3-ease'
import './sequence-renderer.css'

export const unsecableSpaces = (str) => {
  return str.replace(/\s([?!:])/g, '&nbsp;$1')
}

export const getSafeTemplate = (reactElement) => sanitize(reactElement)

export const SequenceRenderer = ({sequence, gotoSequence, playClickSound, theme, styles}) => {

  const [tween, setTween] = useState({ opacity: 1, translate: 0 })
  const [sequenceProps, setSequenceProps] = useState(false)

  const { opacity, translate } = useSpring({
    config: { duration: 350, easing: easings.easeCubic },
    onRest: () => {
      const {next, action, condition} = sequenceProps || {}
      if (tween.immediate) {
        setSequenceProps(null)
        setTween({ opacity: 1, translate: 0, immediate: false})
        gotoSequence(next, action, condition)
      } else if (tween && tween.opacity === 0) {
        setTween({ opacity: 0, translate: 100, immediate: true })
      }
    },
    ...tween
  })

  const prepareNextSequence = (sequence) => {
    playClickSound()
    setSequenceProps(sequence)
    setTween({ opacity: 0, translate: -100 })
  }

  const getTweenTransform = (t) => {
    const animationStyle = sequenceAnimations.getAnimationStyle(theme.styles.animations ? theme.styles.animations.sequence : null)
    return animationStyle(t)
  }

  const animatedStyles = {
    opacity,
    transform: translate.interpolate(getTweenTransform),
    ...styles.textStyle
  }

  return (
    <animated.div className="sequence" style={animatedStyles}>
     { sequence && (
        <Fragment>
          <div className="sequence-content">
            <div style={ styles.sequence } dangerouslySetInnerHTML={{__html: unsecableSpaces(getSafeTemplate(sequence.content))}}/>
          </div>
          <div className="sequence-actions">
            { sequence.choices && sequence.choices.length > 0 ? sequence.choices.map((choice, index) => (
              <div key={'choice-' + index}>
                <button style={ styles.button } onClick={() => prepareNextSequence(choice)}><div dangerouslySetInnerHTML={{__html: unsecableSpaces(getSafeTemplate(choice.content))}} /></button>
              </div>
            )) : (
              <Fragment>
                { (sequence.final || !sequence.next) ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {/*<button style={{ ...styles.button, padding: '0.3em 0.35em' }}><Icon name='star' style={{ margin: 0 }} /></button>*/}
                    <button style={{ ...styles.button, fontSize: '2em', padding: '0.3em 0.35em' }} onClick={() => prepareNextSequence(sequence)}><Icon name='repeat' style={{ margin: 0 }} /></button>
                    {/*<button style={{ ...styles.button, padding: '0.3em 0.35em' }}><Icon name='share alternate' style={{ margin: 0 }} /></button>*/}
                  </div>
                ) : (
                  <button style={ styles.button } onClick={() => prepareNextSequence(sequence)}><Icon name='caret right' style={{ margin: 0 }} /></button>
                )}
              </Fragment>
            )}
          </div>
        </Fragment>
      )}
    </animated.div>
  )
}